export const setItem = (itemName, value) => {
  window.sessionStorage.setItem(itemName, JSON.stringify(value));
};

export const getItem = (itemName, deafultReturnValue) => {
  try {
    return JSON.parse(window.sessionStorage.getItem(itemName)) || deafultReturnValue;
  } catch (e) {
    return deafultReturnValue;
  }
};

export const removeItem = (itemName) => {
  window.sessionStorage.removeItem(itemName);
};

export default {
  setItem,
  getItem,
  removeItem
};
